<template>
  <div class="animated fadeIn">
    <b-card :title="'Ticket <b>Details</b>'" sub-title="">
      <b-form-row class="form-detail">
        <b-col md="6">
          <b-form-group
                label="Name" label-for="name"
                label-class="font-weight-bold"
                :horizontal="true">
            <label class="top-padding-6">{{task.name}}</label>
          </b-form-group>
          <b-form-group
                label="Site"
                label-for="site"
                label-class="font-weight-bold"
                :horizontal="true">
            <label class="top-padding-6">{{ task.site !== null && task.site !== '' ? task.site.name : '' }}</label>
          </b-form-group>
          <b-form-group
                label="Created By" label-for="name"
                label-class="font-weight-bold"
                :horizontal="true">
            <label class="top-padding-6">{{task.createdBy.value.name}}</label>
          </b-form-group>
          <b-form-group
                label="Assign to" label-for="name"
                label-class="font-weight-bold"
                :horizontal="true">
            <label class="top-padding-6">{{task.assigned.value.name}}</label>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
                label="Status"
                label-for="taskStatus"
                label-class="font-weight-bold"
                :horizontal="true">
            <label class="top-padding-6">
              <b-badge
                :variant="getStatusColor(task.taskStatus)">
                {{task.taskStatus}}
              </b-badge>
            </label>
          </b-form-group>
          <b-form-group
                label="Created Time"
                label-for="createdAt"
                label-class="font-weight-bold"
                :horizontal="true">
            <label class="top-padding-6">{{ task.createdAt }}</label>
          </b-form-group>
          <b-form-group
                label="Updated Time"
                label-for="updatedAt"
                label-class="font-weight-bold"
                :horizontal="true">
            <label class="top-padding-6">{{ task.updatedAt }}</label>
          </b-form-group>
        </b-col>
        <b-col md="12" class="top-padding-6">
          <b-form-group
                label="<h4>Visited Sites <b>Log</b></h4>"
                label-for="actions"
                style="margin: 2rem auto 1rem">
            <table class="table table-striped" style="margin-top:20px;">
              <thead>
                <tr>
                  <th>Start Time</th>
                  <th>End Time</th>
                  <th>Site</th>
                  <th>Description</th>
                  <th>Photo</th>
                </tr>
              </thead>
              <tbody v-if="sites.length > 0">
                <tr v-for="site in sites" :key="site.uuid">
                  <td style="vertical-align:middle">{{setDate(site.startTime)}}</td>
                  <td style="vertical-align:middle">{{setDate(site.endTime)}}</td>
                  <td style="vertical-align:middle">{{site.site.name}}</td>
                  <td style="vertical-align:middle"><b-badge :variant="site.description === 'At Site' ? 'warning' : 'primary'">{{site.description}}</b-badge></td>
                  <td style="vertical-align:middle">
                    <div v-viewer>
                        <label v-if="site.photos.length == 0" class="text-secondary top-padding-6">&nbsp;&nbsp; No photo submitted</label>
                        <b-img fluid class="icon-large img-fluid" :src="p.path" v-for="(p, index) in site.photos" :key="index" />
                      </div>
                  </td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td colspan="5" class="text-sedcondary text-center">Visited Site has no data</td>
                </tr>
              </tbody>
            </table>
          </b-form-group>
        </b-col>
      </b-form-row>
      <progress-loader ref="progress"></progress-loader>
      <div slot="footer">
        <b-row>
          <b-col md="6" class="d-md-down-none">
            <b-button
                  @click="goBack()"
                  variant="light"
                  class="btn-pill">
              <i class="fa fa-arrow-left"></i> Back
            </b-button>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import axios from 'axios'
import progressLoader from '@/views/components/progressLoader'
import moment from 'moment'
import Viewer from 'v-viewer'
import Vue from 'vue'

Vue.use(Viewer)

export default {
  name: 'taskCreate',
  components: {
    axios,
    progressLoader
  },
  data () {
    return {
      apiUrlGetDetail: window.AppConfig.apiUrl + 'task',
      apiUrlTaskNote: window.AppConfig.apiUrl + 'task-note?task_uuid=',
      apiUrlTaskPhoto: window.AppConfig.apiUrl + 'task-photo?task_uuid=',
      apiUrlStatus: window.AppConfig.apiUrl + 'task-status-log?ascending=1',
      task: {
        uuid: null,
        assigned: {
          value: []
        },
        site: null,
        // complain: null,
        createdAt: null,
        createdBy: {
          value: []
        },
        name: null,
        request: null,
        requestedBy: {
          value: []
        },
        taskCategory: null,
        taskStatus: null,
        updatedAt: null
      },
      taskNote: [],
      taskPhoto: [],
      taskStatusLog: [],
      sites: []
    }
  },
  mounted () {
    this.getDetailInfo()
    this.getVisisted()
    // this.getTaskPhoto()
    // this.initDropdownOptions_TaskStatus()
  },
  watch: {
    '$route.params.id': function (id) {
      this.getDetailInfo()
    }
  },
  methods: {
    getVisisted () {
      axios.get(window.AppConfig.apiUrl + 'site-visit?ascending=0&order=startTime&task_uuid=' + this.$route.params.id)
        .then(response => {
          response.data._embedded.siteVisit.forEach((siteVisit) => {
            axios.get(window.AppConfig.apiUrl + 'site-visit-photo?site_visit_uuid=' + siteVisit.uuid)
              .then(response => {
                this.sites.push({
                  uuid: siteVisit.uuid,
                  startTime: siteVisit.startTime,
                  endTime: siteVisit.endTime,
                  site: siteVisit.site,
                  description: siteVisit.description,
                  photos: response.data._embedded.siteVisitPhoto
                })
                // this.photos = response.data._embedded.siteVisitPhoto
              })
              .catch(error => {
                this.$store.dispatch('errorMessage', error)
                  .then(errMsg => {
                    this.$alertify.error(errMsg)
                  })
                // window.history.back()
              })
          })
        })
        .catch(error => {
          this.$store.dispatch('errorMessage', error)
            .then(errMsg => {
              this.$alertify.error(errMsg)
            })
          // window.history.back()
        })
    },
    getPhotos (uuid) {
    },
    initDropdownOptions_TaskStatus () {
      axios.get(this.apiUrlStatus + '&task_uuid=' + this.$route.params.id)
        .then(response => {
          if (response !== undefined) {
            this.taskStatusLog = response.data._embedded.taskStatusLog
            for (let i = 0; i < this.taskStatusLog.length; i++) {
              this.taskStatusLog[i]['createdAt'] = moment(this.taskStatusLog[i]['createdAt']).format(window.AppConfig.dateFormat)
              this.taskStatusLog[i]['updatedAt'] = moment(this.taskStatusLog[i]['updatedAt']).format(window.AppConfig.dateFormat)
            }
          }
        })
        .catch(function (error) {
          this.$store.dispatch('errorMessage', error)
            .then(errMsg => {
              this.$alertify.error(errMsg)
            })
        }) // .bind(this)
    },
    getDetailInfo () {
      axios.get(this.apiUrlGetDetail + '/' + this.$route.params.id)
        .then(response => {
          window.setDetailValue(this.task, response.data)
        })
        .catch(error => {
          this.$store.dispatch('errorMessage', error)
            .then(errMsg => {
              this.$alertify.error(errMsg)
            })
          window.history.back()
        })
    },
    getTaskNote () {
      axios.get(this.apiUrlTaskNote + this.$route.params.id)
        .then(response => {
          this.taskNote = response.data._embedded.taskNote
          for (let i = 0; i < this.taskNote.length; i++) {
            this.taskNote[i]['createdAt'] = moment(this.taskNote[i]['createdAt']).format(window.AppConfig.dateFormat)
          }
        })
        .catch(error => {
          this.$store.dispatch('errorMessage', error)
            .then(errMsg => {
              this.$alertify.error(errMsg)
            })
        })
    },

    getTaskPhoto () {
      axios.get(this.apiUrlTaskPhoto + this.$route.params.id)
        .then(response => {
          this.taskPhoto = response.data._embedded.taskPhoto
          for (let i = 0; i < this.taskPhoto.length; i++) {
            this.taskPhoto[i]['createdAt'] = moment(this.taskPhoto[i]['createdAt']).format(window.AppConfig.dateFormat)
          }
        })
        .catch(error => {
          this.$store.dispatch('errorMessage', error)
            .then(errMsg => {
              this.$alertify.error(errMsg)
            })
        })
    },
    getStatusColor (status) {
      switch (status) {
        case 'Assigned':
          return 'warning'
        case 'Accepted':
          return 'info'
        case 'In Progress':
          return 'primary'
        case 'Completed':
          return 'success'
        default:
          return 'danger'
      }
    },

    setEmptyForm () {
      this.comment.response.value = null
    },

    goBack () {
      window.goBack(this)
    },

    setDate (val) {
      return val !== null ? moment(val).format(window.AppConfig.dateFormat) : ''
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/views/tasks/Detail.vue